import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { UserExamRecord } from '../models/userExamRecord.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UserExamRecordService {
  private apiUrl = environment.apiUrl + '/UserExamRecord';

  http = inject(HttpClient);

  createExamRecord(record: UserExamRecord): Observable<UserExamRecord> {
    return this.http.post<UserExamRecord>(this.apiUrl, record);
  }

  getExamRecords(): Observable<UserExamRecord[]> {
    return this.http.get<UserExamRecord[]>(this.apiUrl);
  }

  getExamRecordsByUserId(userId: number): Observable<UserExamRecord[]> {
    return this.http.get<UserExamRecord[]>(this.apiUrl + '/user/' + userId);
  }

  deleteExamRecord(id: number): Observable<void> {
    return this.http.delete<void>(this.apiUrl + '/' + id);
  }
}
